export const DEFAULT_CURRENCY_CODE = 'USD';
